module.exports = require("./pluginPropVal.vue");